import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link} from 'react-router-dom';
import { fetchCancelOrderProducts } from '../../../redux/actions/cancelOrderAction';

function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}
export default function CancledOrders() {
  const itemsPerPage=10;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch=useDispatch();

  const { canceledproduct=[],totalRecords, error } = useSelector(
    (state) => state.cancleProductState
  );

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      dispatch(fetchCancelOrderProducts(currentPage, itemsPerPage));
    } finally {
      setLoading(false);
    }
  };

  fetchData();
  }, [dispatch,currentPage, itemsPerPage]);

  const totalPages = Math.ceil(totalRecords/ itemsPerPage);

  if (loading) {
    return <p className="text-center mt-10">Loading Cancel orders...</p>;
  }

  if(error){
    return(<p className="text-red-600">{error}</p>);
  }

  return (
    <div className='py-2 md:py-4 px-0 lg:px-8 xl:px-10'>
      <p className='font-medium text-sm md:text-base xl:text-lg pb-3'>Total : {totalRecords} Cancelled orders</p>
      {canceledproduct.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
        {canceledproduct.map((row,idx)=>(
        <div key={idx} className='flex flex-col space-y-2 border border-pink-200 rounded-md p-2 lg:p-4 bg-[#fcf8f8]'>
          <p className="font-medium text-sm md:text-base xl:text-lg">Order id : {row.orderId}</p>
          <div className="flex flex-row gap-2 justify-between" key={idx}>
            <div className="flex flex-col space-y-1 w-1/2">     
                <p className="text-xs md:text-sm xl:text-base">Name: {row.orderItem.product.productName}</p>         
                <p className="text-xs md:text-sm xl:text-base">Total ordered items : {row.orderItem.quantity}</p>
                <p className="text-xs md:text-sm xl:text-base">
                    Cancle Date: {new Date(row.createdAt).toLocaleDateString("en-US", 
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })}
                </p>
                <p className="text-xs md:text-sm xl:text-base">
                  RefundAmount : {formatNumber(row.refundAmount)}
                </p>
                <p className='text-sm xl:text-[15px] font-normal py-1.5'> Refund Status :{" "}
                <span
                  className={`font-medium ${
                        row.status === "pending" 
                        ? "text-blue-500"    
                        : "text-green-500"   
                      }`}
                      >
                        {row.status==="pending"? "Not Initiated" : "Refund Completed"}
                </span>
            </p>
            </div>
            <div className="flex items-start text-end space-y-1 w-1/2">
              {row.orderItem.product.images.length > 0 ?(
                  <img
                      src={row.orderItem.product.images?.[0]} 
                      alt={row.orderItem.product.images.productName}
                      className="w-full h-20 md:h-28 object-cover rounded-md border"
                    />
              ) : (
                <p className="font-medium text-sm md:text-base xl:text-lg">No image available</p>
              )}                 
            </div>
          </div>
          <p className='font-medium text-[13px] md:text-[15px] xl:text-[17px]'>Cancel reason : {row.reason}</p>
        </div>
        ))}
        </div>
      ) : (
        <div className="text-gray-600 flex flex-col justify-center space-y-4 w-full">
          <p>No orders found for your account.</p>
          <Link to="/">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Products</button>
          </Link>
        </div>
    )}

    {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">
          <button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<<"}
          </button>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<"}
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) =>
              page === 1 ||
              page === totalPages ||
              Math.abs(currentPage - page) <= 1
            )
            .reduce((acc, page, i, arr) => {
              if (i > 0 && page - arr[i - 1] > 1) acc.push("...");
              acc.push(page);
              return acc;
            }, [])
            .map((page, i) =>
              page === "..." ? (
                <span key={`dots-${i}`} className="px-2 py-1 text-sm text-gray-500">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 text-sm rounded border font-medium ${
                    currentPage === page
                      ? "bg-pink-600 text-white"
                      : "hover:bg-pink-100"
                  }`}
                >
                  {page}
                </button>
              )
            )}

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">"}
          </button>
          <button
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">>"}
          </button>
        </div>
    )}
    </div>

  )
}
